module.exports = __webpack_public_path__ + "img/1523536413.08079189.jpg";